import { TrashIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useRolodexEdit } from 'features/fde'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVPrimitive, RolodexEntryPatchJson } from 'types'

const StyledTrashIcon = styled(TrashIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const DeletePrimitiveButton: FC<{
  primitiveId: string
}> = ({ primitiveId }) => {
  const {
    sendKVCommand,
    selectedMarkup,
    setSelectedMarkup,
    kestrelModel,
    primitives,
    setPrimitives,
  } = useKestrel()
  const { rolodexPatch } = useRolodexEdit()

  const deletePrimitive = (e: React.MouseEvent) => {
    e.stopPropagation()
    let filteredPrimitives: KVPrimitive[] = []
    if (primitives) {
      filteredPrimitives = primitives.filter((p) => p.id !== primitiveId)
    }
    if (sendKVCommand) {
      setPrimitives(filteredPrimitives)
      sendKVCommand({
        command: KestrelCommands.DELETE_PRIMITIVE,
        primitiveId: primitiveId,
      })
      if (selectedMarkup?.id === primitiveId) setSelectedMarkup(undefined)
      // Delete from Rolodex
      const patchData: RolodexEntryPatchJson = {
        id: kestrelModel?.id ?? '',
        data: {
          primitives:
            filteredPrimitives?.map((p) => KVPrimitive.toJSON(p)) ?? [],
        },
      }
      rolodexPatch([patchData])
    }
  }

  return (
    <TooltipWrapper label='Delete primitive' side='top'>
      <div
        style={{ cursor: 'pointer', marginLeft: '-4px' }}
        onClick={(e) => deletePrimitive(e)}>
        <StyledTrashIcon width={22} height={22} />
      </div>
    </TooltipWrapper>
  )
}
